import { Autocomplete, TextField } from "@mui/material";
import { FlussMetadataOption } from "./node-properties/fluss-node-panel-data";

const roleLabel = (role: FlussMetadataOption) => role.label || role.name;

// Any active role of sys_roles (here a role is a permission, not a work queue like QueueSelect).
// Value = role names, same convention as `assigneeRole`.
export const MultiRoleSelect = ({ value, onChange, roles, label, placeholder, disabled = false, size }: {
    value: string[];
    onChange: (names: string[]) => void;
    roles: FlussMetadataOption[];
    label: string;
    placeholder?: string;
    disabled?: boolean;
    size?: "small" | "medium";
}) => {
    const options = roles
        .filter((role) => role.active !== false)
        .slice()
        .sort((a, b) => roleLabel(a).localeCompare(roleLabel(b)));
    // Names no longer in the list (deleted/inactive roles) stay visible as chips.
    const selected: FlussMetadataOption[] = value.map((name) =>
        options.find((candidate) => candidate.name === name) || { id: name, name }
    );

    return <Autocomplete
        multiple
        fullWidth
        size={size}
        disabled={disabled}
        options={options}
        filterSelectedOptions
        getOptionLabel={roleLabel}
        isOptionEqualToValue={(option, current) => option.name === current.name}
        value={selected}
        onChange={(_, next) => onChange(next.map((role) => role.name))}
        renderInput={(params) => (
            <TextField {...params} label={label} placeholder={value.length === 0 ? placeholder : undefined} />
        )}
    />;
};

export default MultiRoleSelect;
